"use strict";
exports.__esModule = true;
exports.getTrackingData = void 0;
var getTrackingData = function () {
    try {
        var clickId = JSON.parse(sessionStorage.getItem("@capitalise/clickId"));
        return clickId;
    }
    catch (e) {
        var clickIdValue = sessionStorage.getItem("@capitalise/clickId");
        if (clickIdValue) {
            return { clickId: clickIdValue, clickIdSource: "impact" };
        }
    }
};
exports.getTrackingData = getTrackingData;
